import { User } from '@/domain/User';
import { Services } from '@/infra/services';
import { CART_ID } from '@/utils/constants/cookies';
import { CART_ID_HEADER } from '@/utils/constants/headers';
import { cookies } from '@/utils/cookies';

export async function getUserResources() {
  const cartId = cookies.client.get(CART_ID)?.value;

  const options = cartId ? { headers: { [CART_ID_HEADER]: cartId } } : {};

  const response = await Services.User.getUserResources(options);

  const domainProps = {
    id: response.id,
    name: response.name,
    email: response.email,
    phone: response.phone,
    picture: response.picture,
    cartItems: response.cartItems,
    profileUrl: response.user_url,
    isLegalUser: response.isLegalUser,
    isEmployee: response.isEmployee,
    trackingId: response.userTrackingId,
    context: response.context,
    zipCode: response.zipCode,
  };

  return new User(domainProps);
}
